import "./App.scss";
import Header from "./components/Header/Header";
import { Outlet, useLocation } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store/store";
import { SideMenu } from "./components/SideMenu/SideMenu";
import { useEffect, useState } from "react";
import {
  useMsal,
  MsalAuthenticationTemplate,
  UnauthenticatedTemplate,
  AuthenticatedTemplate,
} from "@azure/msal-react";
import { useGetToken } from "./hooks/useAppToken";
import axios from "axios";
import { Button } from "./components/CommonUIComponents/Button/Button";
import { LoadingIndicator } from "./components/CommonUIComponents/LoadingIndicator/LoadingIndicator";
import { AutoLogout } from "./components/AutoLogout/AutoLogout";
import { ConsentGate } from "./components/ConsentGate/ConsentGate";
import { setUser } from "./store/slices/userSlice";
import { InteractionType } from "@azure/msal-browser";

import { useDispatch } from "react-redux";
const UserInterceptorProvider = () => {
  const { accounts, instance } = useMsal();
  const dispatch = useDispatch();
  const account = accounts[0];
  useEffect(() => {
    if (!account) return;
    dispatch(setUser(account));
    instance.setActiveAccount(account);
  }, [account, instance, dispatch]);

  return null;
};

function App() {
  const [isSideMenuCollapsed, setSideMenuCollapsed] = useState(true);
  const location = useLocation();
  const [isConfigSet, setIsConfigSet] = useState(false);
  const { instance, accounts } = useMsal();
  const account = accounts[0];
  const useAuthHeader = process.env.REACT_APP_USE_AUTH_HEADER !== "false";

  const isHomePage = location.pathname === "/home" || location.pathname === "/";
  const token = useGetToken();

  useEffect(() => {
    if (!account) return;
    if (useAuthHeader && !token) return;

    const interceptorId = axios.interceptors.request.use((config) => {
      config.headers = config.headers || {};
      if (useAuthHeader && token && !config.headers["Authorization"])
        config.headers["Authorization"] = `Bearer ${token}`;
      config.baseURL = process.env.REACT_APP_API_URL_DEFAULT;
      config.headers["X-Frame-Options"] = "DENY";
      config.headers["Content-Security-Policy"] = "frame-ancestors 'none'";
      config.headers["secure"] = true;
      config.headers["httpOnly"] = true;
      return config;
    });

    setIsConfigSet(true);

    return () => {
      axios.interceptors.request.eject(interceptorId);
    };
  }, [token, account, useAuthHeader]);

  useEffect(() => {
    if (window.top !== window.self) {
      window.top.location = window.self.location;
    }
  }, []);

  const initializeSignIn = () => {
    instance.loginRedirect();
  };

  return (
    <div className="motif-theme-dark main-div">
      <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
        <AuthenticatedTemplate>
          <Provider store={store}>
            <UserInterceptorProvider />
            <AutoLogout />
            <LoadingIndicator show={!isConfigSet} fullscreen={true}>
              <ConsentGate>
                <div className="App">
                  <Header
                    setSideMenuCollapsed={() =>
                      setSideMenuCollapsed(!isSideMenuCollapsed)
                    }
                    isHomePage={isHomePage}
                  />

                  <div className="app-body">
                    {!isHomePage && (
                      <SideMenu isSideMenuCollapsed={isSideMenuCollapsed} />
                    )}
                    <div
                      className={`app-body-content ${
                        isHomePage
                          ? "app-side-menu-hidden"
                          : isSideMenuCollapsed
                            ? "app-side-menu-collapsed"
                            : "app-side-menu-expanded"
                      }`}
                    >
                      <Outlet />
                    </div>
                  </div>
                </div>
              </ConsentGate>
            </LoadingIndicator>
          </Provider>
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <Provider store={store}>
            <div className="App">
              <Header />
              <Button className={"asd"} onClick={initializeSignIn}>
                Click me
              </Button>
            </div>
          </Provider>
        </UnauthenticatedTemplate>
      </MsalAuthenticationTemplate>
    </div>
  );
}

export default App;
